import { render } from "./GarageGateCard.vue?vue&type=template&id=1e67f393&scoped=true"
import script from "./GarageGateCard.vue?vue&type=script&lang=js"
export * from "./GarageGateCard.vue?vue&type=script&lang=js"

import "./GarageGateCard.vue?vue&type=style&index=0&id=1e67f393&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e67f393"]])

export default __exports__